module.exports = __webpack_public_path__ + "img/a10.3fdacd81.jpg";